<template>
  <div class="flex flex-col justify-center min-h-screen py-12 bg-gray-50 sm:px-6 lg:px-8">
    <div class="flex flex-col items-center mb-8">
      <span @click="$router.push('/')">
        <LogoText :dark-mode="$store.state.ui.darkMode" />
      </span>
      <h2 class="mt-4 text-2xl font-semibold text-center text-light-body-text dark:text-dark-body-text">
        {{ $t("Recover Password") }}
      </h2>
    </div>
    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-lg">
      <div class="px-4 py-8 bg-white shadow sm:rounded-lg sm:px-10">
        <!-- Sign-In Form -->
        <Form :validation-schema="schema" class="mt-2 space-y-6" @submit="onSubmit">
          <TextInput
            input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
            name="email"
            type="email"
            :label="$t('E-mail')"
            :placeholder="$t('Your email address')" />
          <div v-if="show_confirm_msg" class="text-md text-green-600 mt-1">
            {{ $t("We have sent you an email with instructions to recover your password.") }}
          </div>

          <button type="submit" class="w-full py-2 mt-5 text-base font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700">
            {{ $t("Recover Password") }}
          </button>

          <!-- Links Section -->
          <div class="flex flex-col items-center justify-between mt-4 gap-2">
            <router-link to="login" class="text-md font-medium text-blue-600 hover:underline dark:text-blue-400">
              {{ $t("Sign In") }}
            </router-link>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import * as Yup from "yup"
import { ref } from "vue"
import LogoText from "@/components/shared/LogoText.vue"
import { Form } from "vee-validate"
import TextInput from "@/components/shared/TextInput.vue"
import AuthService from "@/services/auth.service"
export default {
  name: "Login",

  components: {
    TextInput,
    LogoText,
    Form
  },
  setup() {
    const show_confirm_msg = ref(false)
    const schema = Yup.object().shape({
      email: Yup.string().email().required()
    })

    return {
      show_confirm_msg,
      schema
    }
  },

  methods: {
    onSubmit(values, { resetForm }) {
      this.$store.dispatch("ui/showLoading")
      if (values.email) {
        AuthService.recoverPassword(values.email).then(
          () => {
            this.$store.dispatch("ui/hideLoading")
            this.show_confirm_msg = true
            resetForm()
          },
          () => {
            this.$store.dispatch("ui/hideLoading")
          }
        )
      }
    }
  }
}
</script>
